// extracted by mini-css-extract-plugin
module.exports = {"dialog":"style__dialog___2xhWJ","toolbar":"style__toolbar___eSzMt"};